import {
    SET_SCREEN_WIDTH_SUCCESS,
    SET_SCREEN_WIDTH_FAILURE,
  } from "../../Action/actionTypes";
  
  const initialState = {
    width: null,
    error: false,
  };
  
  const screenWidthReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_SCREEN_WIDTH_SUCCESS:
        return {
          ...state,
          width: action.payload,
          error: false,
        };
      case SET_SCREEN_WIDTH_FAILURE:
        return {
          ...state,
          width: null,
          error: true,
        };
      default:
        return state;
    }
  };
  
  export default screenWidthReducer;
  